export default "__VITE_ASSET__DS$RETjN__"